import axios from 'axios';
import offlineAdapter from '@/lib/offline/adapter';
import { wireReplayTriggers } from '@/lib/offline/queue';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  adapter: offlineAdapter,
});

wireReplayTriggers();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('device_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem('device_token')) {
      localStorage.removeItem('device_token');
      window.dispatchEvent(new Event('auth-expired'));
    }
    return Promise.reject(err);
  }
);

export default api;
